import React from "react";
import { Strings } from "src/constants";
import { Modals } from "src/helpers";
import { MainButton } from "../button/mainButton";
import Modal from "../modal/modal";

export function ConfirmPushNotificationPopup(props: any) {

    const handleYes = () => {
        props.onSaveWithPushNotification();
        props.changeModal(Modals.NONE);
    }

    const handleNo = () => {
        props.onSaveWithoutPushNotification();
        props.changeModal(Modals.NONE);
    }

  return (
      <Modal
          className={`${props.currentModal === Modals.PUSH_NOTIFICATION ? "flexible" : ""}`}
          dialogExtraClassName="confirm-delete"
          isShow={props.currentModal === Modals.PUSH_NOTIFICATION}
          footerChildren={
              <React.Fragment>
                  <MainButton
                      className="btn btn-primary confirmChange close"
                      onSubmit={handleYes}
                      title={Strings.YES}
                      enabled
                  />
                  <MainButton
                      className="btn btn-primary confirmChange close"
                      onSubmit={handleNo}
                      title={Strings.NO}
                      enabled
                  />
              </React.Fragment>
      }
    >
      <h4 className="text_bold mb20">{Strings.CONFIRM}</h4>
      <h5>{Strings.CONFIRM_PUSH_NOTIFICATION}</h5>
    </Modal>
  );
}
